var _key_value_util = require('./_key_value_util');

function _Hash (o, a) {
	// body...
	this._object = o;
	this.object = {};
	this.hash = a? a: '#';

	this.reset();
};

_Hash.prototype.reset = function() {
	this.object = $.extend({}, this._object);
	return this;
};

_Hash.prototype.get = function(key) {
	return this.object[key];
};

_Hash.prototype.set = function(k, v) {
	this.object[k] = v;
	return this;
};

_Hash.prototype.toString = function() {
	return this.hash + _key_value_util.object2String(this.object);
};

_Hash.prototype.go = function(k, v, t) {
	if (t) {
		this.reset();
	}
	if (k) {
		this.set(k, v);
	};
	window.location.href = this.toString();
};

module.exports = {
	initByHashString: function (s) {
		if (!s) {
			s = '#';
		}
		if (s.indexOf('#') != 0) {
			console.log('不合法的 hash');
			return false;
		}
		var o = _key_value_util.string2Object(s.substr(1));
		return this.initByHashObject(o);
	},
	initByHashObject: function (o) {
		return new _Hash(o);
	},
	_Hash: _Hash
}


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/url_util/hash_util.js
// module id = 246
// module chunks = 1